import React, { useEffect } from 'react';
import {
  paymentMethodService,
  paymentMethodQuery,
  PaymentMethodForms,
  FormStatus,
  corporateAccountService,
  corporateAccountQuery,
} from '@lib/state';
import {
  useObservable,
  Section,
  AddPaymentMethodButton,
  Feedback,
  useFormEvents,
} from '@lib/common';
import { PaymentMethodComponent } from './payment-method.component';
import { Typography } from '@material-ui/core';

export const PaymentMethodsForm: React.FC = () => {
  const paymentMethods = useObservable(paymentMethodQuery.paymentMethods);
  const myCorporateAccounts = useObservable(corporateAccountQuery.accounts);
  const accountsLoading = useObservable(corporateAccountQuery.loading);
  // delegates can't save cards (the API rejects it), so don't offer to add one
  const isDelegate = myCorporateAccounts.length > 0;

  useEffect(() => {
    paymentMethodService.getPaymentMethodsForProfile();
    corporateAccountService.getMyAccounts();
  }, []);

  const [{ status, error }] = useFormEvents(PaymentMethodForms.DeletePaymentMethod);

  return (
    <Section
      title="Payment Methods"
      variant="contained"
      right={
        !accountsLoading && !isDelegate && paymentMethods.length < 10 && <AddPaymentMethodButton />
      }
    >
      <Feedback show={!accountsLoading && !isDelegate && paymentMethods.length > 9} severity="info">
        You now have 10 saved payment methods, to add a new one please delete a payment method
        bellow
      </Feedback>
      <Feedback show={isDelegate} severity="info">
        Delegate accounts can't save new payment methods. You can still delete saved ones below.
      </Feedback>
      {!paymentMethods?.length ? (
        <Typography>No payment methods</Typography>
      ) : status === FormStatus.Pending ? (
        <div>Loading...</div>
      ) : (
        paymentMethods
          .sort(x => (!!x.defaultMethod ? -1 : 1))
          .map(paymentMethod => (
            <PaymentMethodComponent
              key={paymentMethod.authNetPaymentId}
              paymentMethod={paymentMethod}
              onDelete={() =>
                paymentMethodService.deletePaymentMethod(paymentMethod.authNetPaymentId)
              }
              status={status}
              error={error}
            />
          ))
      )}
    </Section>
  );
};
